import React, { useState } from 'react';
import './RoomTable.css';
import { toast, ToastContainer } from 'react-toastify';
import apiService from '../api/apiService';
import Pagination from './Pagination/Pagination';
import ConfirmDeleteModal from './ConfirmDeleteModal';
const RoomTable = ({ rooms, setRooms, handleEditClick, hotelId }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const sortedRooms = Array.isArray(rooms)
    ? [...rooms].sort((a, b) => a.room_number - b.room_number)
    : [];
  const currentRows = sortedRooms.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.max(Math.ceil(rooms.length / rowsPerPage), 1);

  const [deleteConfirm, setDeleteConfirm] = useState({
    isOpen: false,
    id: null,
  });

  const confirmDelete = id => {
    if (!id) return;
    setDeleteConfirm({ isOpen: true, id });
  };

  const handleDelete = async () => {
    try {
      const response = await apiService.delete(
        `/rooms/${deleteConfirm.id}/?hotel=${hotelId}`
      );
      console.log(response);
      toast.error('Room deleted successfully!');
      setRooms(prevData =>
        prevData.filter(item => item.id !== deleteConfirm.id)
      );
    } catch (err) {
      console.log(err);
      toast.error('Failed to delete! Please try again.');
    } finally {
      setDeleteConfirm({ isOpen: false });
    }
  };

  return (
    <div className="room-table-container">
      <table className="room-table" style={{ minHeight: '350px' }}>
        <thead>
          <tr>
            <th>Room Number</th>
            <th>Room Type</th>
            <th>Bed Type</th>
            <th>Room Floor</th>
            <th>Room Facility</th>
            <th>Status</th>
            <th>Housekeeping Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {currentRows.map(room => (
            <tr key={room.id}>
              <td>{room.room_number}</td>
              <td>{room.room_type.name}</td>
              <td>
                {room.bed_type.charAt(0).toUpperCase() + room.bed_type.slice(1)}
              </td>
              <td>
                {room.room_floor === 0
                  ? 'Ground'
                  : room.room_floor === 1
                  ? 'First'
                  : room.room_floor === 2
                  ? 'Second'
                  : room.room_floor === 3
                  ? 'Third'
                  : room.room_floor}
              </td>
              <td>
                {room.room_facility.charAt(0).toUpperCase() +
                  room.room_facility.slice(1)}
              </td>
              <td className={`status ${room.status.toLowerCase()}`}>
                {room.status.charAt(0).toUpperCase() + room.status.slice(1)}
              </td>
              <td>
                {room.hk_status.charAt(0).toUpperCase() +
                  room.hk_status.slice(1)}
              </td>

              <td>
                <div className="options-menu">
                  <button className="options-button">⋮</button>
                  <div className="dropdown-menu">
                    <button onClick={() => handleEditClick(room)}>Edit</button>
                    {/* <button onClick={() => confirmDelete(room.id)}>
                      Delete
                    </button> */}
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />

      {deleteConfirm.isOpen && (
        <ConfirmDeleteModal
          isOpen={deleteConfirm.isOpen}
          onConfirm={handleDelete}
          onCancel={() => setDeleteConfirm({ isOpen: false, id: null })}
          message="Are you sure you want to delete this room?"
        />
      )}
    </div>
  );
};

export default RoomTable;
